// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2504":"8afc6be8","3035":"b7b91cb1","3837":"8afc6be8","5572":"8afc6be8","6154":"360bec10","7784":"b7b91cb1","7823":"f4d78fc3","8339":"360bec10","8688":"9923b5b2","8871":"b7b91cb1","9591":"360bec10"}[chunkId] + ".chunk.css";
};